enum ApiMessages {
  Success = 'Success.',
  Error = 'An error has occurred. Please try again.',
  SessionExpired = 'Your session has expired. Please login again.',
  AccessDenied = 'Access Denied.',
  NotFound = "Not Found Page."
}

export { ApiMessages };
